import React from "react";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import "./PolicyPages.css";

const sections = [
  {
    num: "01",
    title: "Eligibility for Returns",
    intro: "Returns are accepted only under the following conditions:",
    list: [
      "Wrong product delivered",
      "Damaged product received",
      "Expired or defective item",
    ],
  },
  {
    num: "02",
    title: "Non-Returnable Products",
    intro: "Due to health and safety reasons, the following cannot be returned:",
    list: [
      "Opened food items",
      "Perishable goods",
      "Used products",
      "Items without original packaging",
    ],
  },
  {
    num: "03",
    title: "Return Request Timeframe",
    text: "Customers must report any issue within 48 hours of delivery. Requests after this time period may not be accepted.",
    highlight: true,
  },
  {
    num: "04",
    title: "Return Process",
    intro: "To initiate a return, customers must provide:",
    list: [
      "Order ID",
      "Clear product images",
      "Description of issue",
    ],
  },
  {
    num: "05",
    title: "Refund Policy",
    text: "Approved refunds will be processed within 5–7 business days. Refunds will be credited to the original payment method.",
  },
  {
    num: "06",
    title: "Order Cancellation",
    text: "Orders can be cancelled only before they are shipped. Once shipped, cancellation is not possible.",
  },
];

const ReturnPolicy = () => {
  return (
    <>
      <HeaderOne />

      <section className="policy-hero">
        <div className="policy-hero-inner">
          <p className="policy-hero-eyebrow">Kalpana Mart</p>
          <h1>Return &amp; Refund Policy</h1>
          <p className="policy-hero-sub">
            Your satisfaction matters. Here's how we handle returns, refunds, and cancellations.
          </p>
        </div>
      </section>

      <div className="policy-body">
        <div className="policy-content">
          <div className="policy-meta">
            <span className="policy-badge">
              <span className="policy-badge-dot" />
              Effective immediately
            </span>
          </div>

          <p className="policy-intro">
            Customer satisfaction is our priority. However, due to the nature of food and
            homemade products, we follow a strict return policy to ensure hygiene and safety.
          </p>

          {sections.map((s) => (
            <div className="policy-section" key={s.num}>
              <div className="policy-section-header">
                <span className="policy-section-num">{s.num}</span>
                <h2>{s.title}</h2>
              </div>
              {s.intro && <p style={{ marginBottom: 10 }}>{s.intro}</p>}
              {s.text && !s.highlight && <p>{s.text}</p>}
              {s.text && s.highlight && (
                <div className="policy-highlight">
                  <p>{s.text}</p>
                </div>
              )}
              {s.list && (
                <ul className="policy-list">
                  {s.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>

      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default ReturnPolicy;